/**
 * @Pipe
 * @description pipe to format numeric values to argentina readable currency values
 * @input number
 * @output formatted numeric value
 */

 import { Pipe, PipeTransform } from "@angular/core";

 @Pipe({
   name: "numberFormat"
 })
 export class NumberFormatPipe implements PipeTransform {
   transform(value: any): number {
     return this.localeString(value);
 }
 localeString(nStr) {
   if (nStr === "" || nStr ==undefined || nStr==null) {return "";}
   const specialRegex= /[^A-Z a-z0-9]/ ;
   if(specialRegex.test(nStr)){
     nStr = nStr.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g,'');
   }
   let x, x1, x2, rgx;
   nStr += "";
   x = nStr.split(".");
   x1 = x[0];
   x2 = x.length > 1 ? "," + x[1] : "";
   rgx = /(\d+)(\d{3})/;
   while (rgx.test(x1)) {
    x1 = x1.replace(rgx, "$1" + "," + "$2");
   }
   return x1 + x2;
 }
 }